import { render, staticRenderFns } from "./RunGameCurrent.vue?vue&type=template&id=0a25b3ec&scoped=true&"
import script from "./RunGameCurrent.vue?vue&type=script&lang=js&"
export * from "./RunGameCurrent.vue?vue&type=script&lang=js&"
import style0 from "./RunGameCurrent.vue?vue&type=style&index=0&id=0a25b3ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a25b3ec",
  null
  
)

export default component.exports